
import { Mixins, Component } from 'vue-property-decorator';
import api from '@/api/course';
import BsMixin from '@/views/Home/mixins/bsMixin';
import noData from '@/components/noData/index.vue';
import Box from './box.vue';

@Component({
  components: {
    noData,
    Box,
  },
})
export default class AssetWrapper extends Mixins(BsMixin) {
  private arrs: Array<any> = [];

  public $refs!: {
    list: Element,
  }

  mounted() {
    this.initBS(this.$refs.list);
  }

  getData(pid: string) {
    this.arrs = [];
    return new Promise((resolve, reject) => {
      api.getChapterAsset(pid).then((res: any) => {
        this.arrs = res.map((item: any) => ({
          id: item.id,
          cid: pid,
          title: item.title,
          type: item.type,
          data: `${process.env.VUE_APP_ASSET_HOST}/${item.thumbMd5}.${item.thumbExt}`,
          imgs: item.thumbs ? JSON.parse(item.thumbs).map((em: any) => `${process.env.VUE_APP_ASSET_HOST}/${em}`) : [],
        }));
        resolve(this.arrs);
      });
    });
  }
}
